import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import ellipsis from '/chat/src/common/js/lib/ellipsis';
import {bindActionCreators} from 'redux';
import DateTime from '/chat/src/lib/DateTime';
//import {emojify} from 'react-emojione';
import {Twemoji} from 'react-emoji-render';
import style from './style.scss';

import {Map} from 'immutable';
import Customization from '/chat/src/redux/model/customization/model';
import Ticket from '/chat/src/redux/model/ticket/model';
import {CompanyModel, SystemModel} from '/chat/src/redux/model'
import DefaultProfileImage from '/chat/src/components/DefaultProfileImage';
import TextDisplay from '/chat/src/components/TextDisplay';


class Conversation extends Component {
    constructor() {
        super();
        this.handleConversationClick = this.handleConversationClick.bind(this)
    }

    render(){
        return (
            <div className={style.Conversation} onClick={this.handleConversationClick}>
                {this.renderUnreadEntriesCount()}
                {this.renderSupportProfileImage()}
                {this.renderConversationInformation()}
            </div>
        );
    }

    renderConversationInformation() {
        return (
            <div className={style.ConversationInformation}>
                {this.renderName()}
                {this.renderLastEntry()}
                {this.renderLastEntryTime()}
            </div>
        );
    }


    renderName() {
        let name;
        const unread = this.props.unread;
        if(this.props.assignedEmployee){
            name = this.__getSupportName();
        }else{
            name = this.__getCompanyName();
        }
        return <div
                    style={unread && {fontWeight: 'bold'}}
                    className={style.ConversationItemName}>  {name} </div>
    }
    __getCompanyName() {
        return ellipsis(this.props.name, 33);
    }
    __getSupportName() {
        const assignedEmployee = this.props.assignedEmployee;
        let name = ellipsis(assignedEmployee.get('display_name'), 33);
        if(!name){
            name = ellipsis(assignedEmployee.get('name'), 33);
        }
        return name
    }

    renderLastEntry() {
        const unread = this.props.unread;
        const lastEntry = this.props.lastEntry
        let lastEntryBody = lastEntry.get('entry_body') || '';
        const lastEntryCreator = this.getLastEntryCreatorId();
        const visitorId = this.props.visitor.get('id');
        let you = '';

        if(!lastEntry.get('meta')){
            if (lastEntryCreator == visitorId && !lastEntry.meta){
                you = this.props.language.get('You') + ': '
            }
        }
        return (
            <div className={style.ConversationLastEntry}
                style={unread && {fontWeight: 'bold'}}
                >
                <TextDisplay text={lastEntryBody}/>
            </div>
        );
    }
    renderLastEntryTime() {
        const lastEntry = this.props.lastEntry;
        const dateString = lastEntry.get('date_created');
        if(!dateString)
            return null;

        let time = DateTime.getDetailedNiceDate(dateString);
        return <span className={style.ConversationLastEntryTime}>{time}</span>
    }


    renderSupportProfileImage() {
        if (this.props.assignedEmployee) {
            const assignedEmployeeProfileImageUrl = this.props.assignedEmployee.get('image_url');

            if (assignedEmployeeProfileImageUrl){
                return <img class={style.ProfileImage} src={assignedEmployeeProfileImageUrl} />;
            } else {
                return this.renderBranding();
            }
        }
        return this.renderBranding();
    }

    renderBranding() {
        const companyName = this.props.name;
        const firstLetter = companyName[0].toUpperCase();

        return (
            <div style={{backgroundColor: '#EAEAEA'}} className={style.ProfileImage}>
                <DefaultProfileImage color={this.props.color}/>
            </div>
        );
    }

    renderUnreadEntriesCount() {
        return null;
        if(this.props.unread !== 0)
            return <span className={style.ConversationUnreadEntriesCount}></span>
    }

    getLastEntryCreatorId(){
        return this.props.lastEntry.get('creator_id', '');
    }

    handleConversationClick() {
        this.props.dispatch(Ticket.setCurrentRoom(this.props.room))
        this.props.dispatch(SystemModel.setRoute('Chat'));
    }
}

function mapStateToProps(state, ownProps) {
    const room = ownProps.conversation.get('room')
    const name = Customization.getCompanyDisplayName(state);
    const assignedEmployeeId = Ticket.getAssignedEmployeeId(room , state)

    return {
        room: room,
        language: Customization.getLanguage(state),
        color: Customization.getColor(state),
        unread: Ticket.getUnread(room, state),
        visitor: state.get('user'),
        config: state.get('config'),
        company: state.get('company'),
        unreadEntriesCount: state.get('unreadEntriesCount'),
        assignedEmployee: CompanyModel.getEmployee(assignedEmployeeId, state),
        lastEntry: Ticket.getLastEntry(room, state),
        name: name
    };
}

export default connect(mapStateToProps)(Conversation);



// WEBPACK FOOTER //
// ./routes/Conversations/ConversationItem/index.js